<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
    <template
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="slotProps"
    >
      <slot v-bind:name="name" v-bind="slotProps"></slot>
    </template>

    <template v-slot:footer.prepend>
      <slot name="footer.prepend"></slot>
    </template>
    <template v-slot:loading>
      <slot name="loading"></slot>
    </template>
    <template v-slot:no-data>
      <slot name="no-data"></slot>
    </template>
    <template v-slot:no-results>
      <slot name="no-results"></slot>
    </template>
    <template v-slot:progress>
      <slot name="progress"></slot>
    </template>
  </v-data-table>

</template>

<script>
import { VDataTable } from 'vuetify/lib/components/VDataTable'

export default {
  components: {
    VDataTable,
  },

  props: {
    autoScroll: { type: Boolean },
    targetIdcs: { type: Array },
  },

  watch: {
    autoScroll(autoScroll) {
      if (autoScroll) this.$_autoScroll(this.targetIdx);
    },

    targetIdcs(targetIdcs) {
      if (this.autoScroll) this.$_autoScroll(targetIdcs);
    },
  },

  data() {
    return {
      $_tableBodyElement: undefined,
      $_tableHeadElement: undefined,
      $_tableWrapperElement: undefined,
    };
  },

  mounted() {
    this.$data.$_tableBodyElement = this.$el.getElementsByTagName('tbody')[0];
    this.$data.$_tableHeadElement = this.$el.getElementsByTagName('thead')[0];
    this.$data.$_tableWrapperElement =this.$el.getElementsByClassName('v-data-table__wrapper')[0];
    this.$data.$_tableWrapperElement.addEventListener('wheel', this.$_onWheel, { passive: true });
    this.$data.$_tableWrapperElement.addEventListener('mousedown', this.$_onMousedown);
  },

  beforeDestroy() {
    this.$data.$_tableWrapperElement.removeEventListener('mousedown', this.$_onMousedown);
    this.$data.$_tableWrapperElement.removeEventListener('wheel', this.$_onWheel);
  },

  methods: {
    /* private */
    $_onWheel() { this.$emit('update:auto-scroll', false) },

    $_onMousedown(event) {
      {
        if (isEventOccuredOnScrollBar(event)) this.$emit('update:auto-scroll', false);
      }

      function isEventOccuredOnScrollBar(event) {
        if (event.offsetX < event.target.clientWidth) return false;
        if (event.offsetY > event.target.clientHeight) return false;
        return true
      }
    },

    $_autoScroll(targetIdcs) {
      let scrollOffsetFromTop = undefined;
      if ((targetIdcs === undefined) || (targetIdcs.length === 0)) {
        scrollOffsetFromTop = 0;
      } else {
        let tableBodyElementBoundingClientRect = this.$data.$_tableBodyElement.getBoundingClientRect();
        let tableBodyElementTop = tableBodyElementBoundingClientRect.top;

        let tableHeadElementBoundingClientRect = this.$data.$_tableHeadElement.getBoundingClientRect();
        let tableHeadElementHeight = tableHeadElementBoundingClientRect.height;

        let tableWrapperElementBoundingClientRect = this.$data.$_tableWrapperElement.getBoundingClientRect();
        let tableWrapperElementTop = tableWrapperElementBoundingClientRect.top;
        let tableWrapperElementHeight = tableWrapperElementBoundingClientRect.height;

        let [ firstRowElementBoundingClientRect, ...remainingRowElementBoundingClientRects ] = targetIdcs.map(
          targetIdx => this.getTableRowElement(targetIdx).getBoundingClientRect(),
        );

        let minTopRowElementBoundingClientRect = firstRowElementBoundingClientRect;
        let maxBottomRowElementBoundingClilentRect = firstRowElementBoundingClientRect;
        for (let boundingClientRect of remainingRowElementBoundingClientRects) {
          if (boundingClientRect.top < minTopRowElementBoundingClientRect.top) {
            /* < (don't update minimum when same) */
            minTopRowElementBoundingClientRect = boundingClientRect;
          }

          if (boundingClientRect.bottom >= maxBottomRowElementBoundingClilentRect.bottom) {
            /* >= (update maximum when same) */
            maxBottomRowElementBoundingClilentRect = boundingClientRect;
          }
        }

        if ((tableWrapperElementTop + tableHeadElementHeight) >= minTopRowElementBoundingClientRect.top) {
          scrollOffsetFromTop = minTopRowElementBoundingClientRect.top - tableBodyElementTop;
        } else if ((tableWrapperElementTop + tableWrapperElementHeight) < maxBottomRowElementBoundingClilentRect.bottom) {
          scrollOffsetFromTop = maxBottomRowElementBoundingClilentRect.top - tableBodyElementTop - tableWrapperElementHeight + maxBottomRowElementBoundingClilentRect.height + tableHeadElementHeight;
        }
      }
      if (scrollOffsetFromTop !== undefined) {
        this.$data.$_tableWrapperElement.scroll({ top: scrollOffsetFromTop });
      }
    },

    /* public */
    getTableRowElement(targetIdx) {
      return this.$data.$_tableBodyElement.children[targetIdx];
    }
  },
};
</script>